import { useCallback, useState } from "react";

/**
 * Whether the Track record panel (components/TrackRecord.jsx) is open. Opened from the rail's
 * Track record item.
 *
 * @returns {{open: boolean, setOpen: Function, toggle: () => void}}
 */
export function useTrackRecord() {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((v) => !v), []);
  return { open, setOpen, toggle };
}
